import {FormattedNumber} from 'react-intl-next';

const DefaultFormattedNumber = FormattedNumber;

FormattedNumber.defaultProps  = {
  minimumFractionDigits: 2,
};

export default FormattedNumber;
